import React, { useState } from "react";
import { Theme } from "@radix-ui/themes";
import { themeConfig } from "../config";
import { GameContainer } from "../components/GameContainer";
import { IntroSplash } from "../components/IntroSplash";
import { shouldSkipIntro } from "../config/dev";

export const HomePage: React.FC = () => {
  const [showGame, setShowGame] = useState(shouldSkipIntro());

  if (!showGame) {
    return <IntroSplash onContinue={() => setShowGame(true)} />;
  }

  return (
    <Theme {...themeConfig.radix}>
      <GameContainer onReturnHome={() => setShowGame(false)} />
    </Theme>
  );
};
